<script setup>
import { onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import { loadPreviousPage } from "@/utils/loadPastPages";
import { newTour } from "@/utils/shepherd/main";
import { replacePage } from "@/utils/pageHistory";
import Hero from "../components/Hero.vue";
import MainContent from "../components/main/MainContent.vue";
import Circles from "../components/Circles.vue";
import TourWelcome from "../components/main/TourWelcome.vue";

const store = useStore();

const checkVersion = () => store.dispatch("checkVersion");
const pageReset = () => store.dispatch("pageReset");
const setIsMobile = (value) => store.dispatch("setIsMobile", value);

// Carry on with a tour when the page is loaded, if one is due
onMounted(() => {
  newTour();
});

// Check the version of the DB, if not correct, destroy the DB and reload the page
onMounted(() => {
  checkVersion();
});

// Back and Forward show the page saved for that history entry. An entry without one
// (from before the page was saved) starts afresh in place, without adding to history.
const popstateHandler = async (event) => {
  const pageId = event.state?.vuexState;
  if (pageId !== undefined && (await loadPreviousPage(store, pageId))) {
    return;
  }
  pageReset();
  replacePage(store.state);
};

onMounted(() => {
  window.addEventListener("popstate", popstateHandler);
});

let resizeHandler;

// Handle mobile view
onMounted(() => {
  resizeHandler = () => {
    // Below the computer layout, which starts at 1024px wide
    setIsMobile(window.matchMedia("(max-width:1023.98px)").matches);
  };
  resizeHandler();
  window.addEventListener("resize", resizeHandler);
});

onUnmounted(() => {
  window.removeEventListener("resize", resizeHandler);
  window.removeEventListener("popstate", popstateHandler);
});
</script>

<template>
  <div class="relative">
    <p class="hidden">
      Use the box below to simply describe what you want to Make and press start
      for the Genie to understand and generate your idea.
    </p>
    <Circles class="z-0" />
    <Hero class="relative" @hide="pageReset" />
    <MainContent />
    <TourWelcome />
  </div>
</template>
